var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6;
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import * as dayjs from 'dayjs';
import translations from './translations';
import css from './style.pcss';
var RTLRadarKontrollen = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLRadarKontrollen, _LitElement);
  function RTLRadarKontrollen() {
    var _this;
    _classCallCheck(this, RTLRadarKontrollen);
    _this = _callSuper(this, RTLRadarKontrollen);
    _this.language = 'lu';
    _this.hidetitle = false;
    _this.apiUrl = "https://api-gate.rtl.lu/traffic/radar-controls";
    if (window.rtlsites) {
      _this.language = window.rtlsites.config.language;
    }
    return _this;
  }
  _createClass(RTLRadarKontrollen, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(RTLRadarKontrollen.prototype), "connectedCallback", this).call(this);
      this._fetchData();
    }
  }, {
    key: "_fetchData",
    value: function _fetchData() {
      var _this2 = this;
      fetch(this.apiUrl).then(function (resp) {
        return resp.json();
      }).then(function (resp) {
        _this2.data = resp;
      });
    }
  }, {
    key: "_getTranslation",
    value: function _getTranslation(key) {
      if (!translations[key]) {
        console.warn(key + ' is not defined in translations.js!');
      } else return translations[key][this.language];
    }
  }, {
    key: "_groupBy",
    value: function _groupBy(xs, key) {
      if (!xs) return;
      return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    }
  }, {
    key: "_renderItems",
    value: function _renderItems(items) {
      var itemsOutput = [];
      for (var key in items) {
        itemsOutput.push(html(_t || (_t = _`<tr class="radar-control__tr radar-control__tr--header"><th class="radar-control__th radar-control__time" colspan="2">${0}</th></tr>`), this._getTranslation(key)));
        for (var i = 0; i < items[key].length; i++) {
          itemsOutput.push(html(_t2 || (_t2 = _`
                    <tr class="radar-control__tr">
                        <td class="radar-control__td radar-control__city">${0}</td>
                        <td class="radar-control__td">${0}</td>
                    </tr>
                `), items[key][i].city, items[key][i].street));
        }
      }
      return itemsOutput;
    }
  }, {
    key: "render",
    value: function render() {
      if (this.data == undefined) return html(_t3 || (_t3 = _``));
      var output = '';
      var items = this._groupBy(this.data, 'time_of_day');
      var class2add = ` flavor-${this.language} `;
      output = html(_t4 || (_t4 = _`
            <style>${0}</style>
            <div class="mobility__container${0}">
                <div class="radar-control">
                    <div class="radar-control__header">
                        ${0}
                        <div class="radar-control__date">${0}</div>
                    </div>

                    <table class="default-table radar-control__table" border="1">
                    ${0}
                    </table>
                </div>
            </div>
        `), css, class2add, !this.hidetitle ? html(_t5 || (_t5 = _`<div class="radar-control__title">${0}</div>`), this._getTranslation('title')) : html(_t6 || (_t6 = _``)), dayjs(this.data.datem).format('DD.MM.YYYY'), this._renderItems(items));
      return output;
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        data: {
          type: String
        },
        language: {
          type: String
        },
        hidetitle: {
          type: Boolean
        }
      };
    }
  }]);
  return RTLRadarKontrollen;
}(LitElement);
export { RTLRadarKontrollen as default };
window.customElements.define('rtl-radar-kontrollen', RTLRadarKontrollen);